import {
  DateField,
  FieldType,
  FilterableField,
  SingleSelectField,
  SingleUserField,
  SourceType,
} from 'components/organisms/tasks/fields';

export enum GroupBy { // TODO: change to const
  None = 'none',
  Status = 'status',
  CustomerName = 'customer_name',
  Progress = 'progress',
  InferredProgress = 'inferred_progress',
  LastStatusUpdate = 'last_status_update',
  ProjectOwner = 'project_manager',
  StartDate = 'start_date',
  DueDate = 'due_date',
}

export type GroupByField = SingleSelectField | DateField | SingleUserField;
export const NoneField: SingleSelectField = {
  fieldName: GroupBy.None,
  fieldLabel: 'None',
  type: FieldType.SingleSelect,
  fieldId: -2000,
  private: false,
  customField: false,
  metaData: {
    options: [],
  },
  sourceType: SourceType.Project,
};

export const isAllowedForGroupBy = ({
  type,
  fieldName,
}: FilterableField): boolean => {
  switch (type) {
    case FieldType.SingleSelect:
    case FieldType.SingleUser:
      return true;
    case FieldType.Date:
      return fieldName === 'dueDate' || fieldName === 'startDate';
    default:
      return false;
  }
};
